import { companyAccent, formatPeriod } from "./format";
import {
  hasEditPlotRatingConfigRole,
  hasExperimentsRole,
} from "../../users/rolesUtil";

import { ButtonAddRemoveUser } from "../../components/ButtonAddRemoveUser";
import PropTypes from "prop-types";
import React from "react";

// Row-based alternative to the campaign bento grid: same tiles, denser layout.
export const CampaignTable = ({
  campaigns,
  actionsVisible,
  onOpen,
  onEditPlotRating,
  onOpenAdmin,
}) => {
  const stop = (event) => event.stopPropagation();

  return (
    <div className="cf-ctable-wrap">
      <table className="cf-ctable">
        <thead>
          <tr>
            <th style={{ width: "30%" }}>Campaign</th>
            <th style={{ width: "22%" }}>Company</th>
            <th style={{ width: "24%" }}>Period</th>
            <th style={{ width: "9%" }}>Sites</th>
            <th className="cf-ctable__actions-head">Actions</th>
          </tr>
        </thead>
        <tbody>
          {campaigns.map((campaign) => (
            <tr
              key={campaign.id}
              className="cf-table__row"
              style={{ "--cf-accent": companyAccent(campaign.company.name) }}
              onClick={() => onOpen(campaign)}
            >
              <td className="cf-table__name">
                {campaign.name}
                {campaign.has_experiment &&
                  hasExperimentsRole(campaign.roles) && (
                    <i
                      className="fa-solid fa-flask ms-2"
                      data-tooltip-id="tooltip"
                      data-tooltip-content="Field map enabled"
                    />
                  )}
              </td>
              <td>{campaign.company.name}</td>
              <td className="cf-table__muted">
                {formatPeriod(campaign.start_date, campaign.end_date)}
              </td>
              <td>{campaign.total_sites ?? 0}</td>
              <td className="cf-table__actions" onClick={stop}>
                {hasEditPlotRatingConfigRole(campaign.roles) && (
                  <button
                    type="button"
                    className="cf-iconbtn"
                    data-tooltip-id="tooltip"
                    data-tooltip-content="Plot rating configuration"
                    onClick={() => onEditPlotRating(campaign)}
                  >
                    <i className="fa-solid fa-pencil" />
                  </button>
                )}
                {actionsVisible && (
                  <>
                    <ButtonAddRemoveUser
                      contract={campaign}
                      company={campaign.company}
                      hasContractAccess
                      className="p-0"
                    />
                    <button
                      type="button"
                      className="cf-iconbtn"
                      data-tooltip-id="tooltip"
                      data-tooltip-content="Open in administration"
                      onClick={() => onOpenAdmin(campaign)}
                    >
                      <i className="fa-solid fa-gears" />
                    </button>
                  </>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

CampaignTable.propTypes = {
  campaigns: PropTypes.array.isRequired,
  actionsVisible: PropTypes.bool,
  onOpen: PropTypes.func.isRequired,
  onEditPlotRating: PropTypes.func.isRequired,
  onOpenAdmin: PropTypes.func.isRequired,
};
